<template>
  <date-filter />
  <hours-filter />
  <hospitals-filter />
  <scales-filter />
  <template v-if="flags.enabledDashboardV2">
    <sector-filter />
    <specialty-filter />
  </template>
  <more-filters />
</template>
<script lang="ts" setup>
import DateFilter from './DateFilter.vue'
import HospitalsFilter from './HospitalsFilter.vue'
import HoursFilter from './HoursFilter.vue'
import ScalesFilter from './ScalesFilter.vue'
import SectorFilter from './SectorFilter.vue'
import SpecialtyFilter from './SpecialtyFilter.vue'
import MoreFilters from './MoreFilters.vue'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'

const { flags } = useFeatureFlags()
</script>
